export default __webpack_public_path__ + "static/media/RTM-4g.bc7474c2.jpg";